'use es6';

import ContentLoading from 'customer-data-sidebar/cards/ContentLoading';
import SidebarCardError from 'customer-data-sidebar/SidebarCardError';
import { logPartialOccurrence, logQueryError } from 'customer-data-sidebar/tracking/loggingActions';
import { NetworkStatus } from '@apollo/client';

/**
 * In GraphQL cards, we'll always need to handle data errors and loading states
 * in a consistent way. This helper serves as a container for this logic to
 * avoid repeating it across multiple components. It accepts the same object
 * that Apollo's Query component supplies to it's child function, as well as a
 * card name for error reporting.
 *
 * @returns {React.Component|null} Either a loading/error state, or null if
 * none is required given the data.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function getAlternateDataState({
  data,
  loading,
  error,
  networkStatus
}, cardKey = 'unknown') {
  if (loading && networkStatus !== NetworkStatus.fetchMore) {
    return /*#__PURE__*/_jsx(ContentLoading, {});
  }
  if (error) {
    logQueryError(`${cardKey.toLowerCase()} card`, {
      message: error.message
    });
    return /*#__PURE__*/_jsx(SidebarCardError, {});
  }
  if (!loading && Object.keys(data || {}).length === 0) {
    logPartialOccurrence(`${cardKey.toLowerCase()} card`, {
      networkStatus
    });
    return /*#__PURE__*/_jsx(ContentLoading, {});
  }
  return null;
}